/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  EnableOpenRouterKeyRequestBody,
  EnableOpenRouterKeyRequestBody$Outbound,
  EnableOpenRouterKeyRequestBody$outboundSchema,
} from "../components/enableopenrouterkeyrequestbody.js";

export type EnableAdminOpenRouterKeySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type EnableAdminOpenRouterKeyRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  enableOpenRouterKeyRequestBody: EnableOpenRouterKeyRequestBody;
};

/** @internal */
export type EnableAdminOpenRouterKeySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const EnableAdminOpenRouterKeySecurity$outboundSchema: z.ZodMiniType<
  EnableAdminOpenRouterKeySecurity$Outbound,
  EnableAdminOpenRouterKeySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function enableAdminOpenRouterKeySecurityToJSON(
  enableAdminOpenRouterKeySecurity: EnableAdminOpenRouterKeySecurity,
): string {
  return JSON.stringify(
    EnableAdminOpenRouterKeySecurity$outboundSchema.parse(
      enableAdminOpenRouterKeySecurity,
    ),
  );
}

/** @internal */
export type EnableAdminOpenRouterKeyRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  EnableOpenRouterKeyRequestBody: EnableOpenRouterKeyRequestBody$Outbound;
};

/** @internal */
export const EnableAdminOpenRouterKeyRequest$outboundSchema: z.ZodMiniType<
  EnableAdminOpenRouterKeyRequest$Outbound,
  EnableAdminOpenRouterKeyRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    enableOpenRouterKeyRequestBody:
      EnableOpenRouterKeyRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      enableOpenRouterKeyRequestBody: "EnableOpenRouterKeyRequestBody",
    });
  }),
);

export function enableAdminOpenRouterKeyRequestToJSON(
  enableAdminOpenRouterKeyRequest: EnableAdminOpenRouterKeyRequest,
): string {
  return JSON.stringify(
    EnableAdminOpenRouterKeyRequest$outboundSchema.parse(
      enableAdminOpenRouterKeyRequest,
    ),
  );
}
